import React from 'react'

const TennisApparel = () => {
    return (
        <div>TennisApparel</div>
    )
}

export default TennisApparel